import React from 'react';

const CorrGuardShield = ({ size = 32, className = '' }) => (
<svg
  aria-hidden="true"
  className={className}
  focusable="false"
  viewBox="0 0 100 120"
  width={size}
  height={Math.round(size * 1.2)}
  preserveAspectRatio="xMidYMid meet"
  xmlns="http://www.w3.org/2000/svg"
>
  <g
    transform="translate(0.000000,106.000000) scale(0.100000,-0.100000)"
    fill="#7cfff9"
    stroke="none"
    fillRule="evenodd"
  >
    <path d="M325 901 c-72 -31 -149 -63 -172 -70 -37 -12 -44 -19 -49 -49 -9 -47 4 -214 23 -292 37 -154 160 -318 290 -388 l59 -31 54 31 c82 46 201 171 239 250 51 107 65 177 65 328 l1 135 -70 26 c-74 27 -76 27 -202 83 -45 20 -87 36 -95 35 -7 0 -71 -26 -143 -58z M594 850 c64 -27 134 -55 156 -61 l40 -12 0 -71 c0 -39 -3 -95 -6 -123 l-7 -53 -73 0 -72 0 -18 45 c-19 52 -26 49 -44 -18 -7 -26 -16 -49 -20 -52 -3 -2 -12 31 -19 73 -16 100 -42 202 -50 202 -8 0 -29 -149 -38 -263 -3 -43 -10 -80 -14 -83 -4 -2 -11 17 -15 43 -8 60 -12 67 -29 53 -11 -9 -15 -4 -21 24 -8 44 -14 45 -37 6 -17 -29 -21 -30 -86 -30 -67 0 -69 1 -76 28 -4 15 -9 69 -11 120 l-4 94 31 11 c18 7 86 35 153 63 67 29 126 52 133 53 6 1 63 -21 127 -49z M515 510 c10 -55 22 -103 26 -106 5 -3 9 -3 9 -1 0 2 11 35 24 73 24 68 25 69 35 40 l11 -29 75 5 c88 6 87 10 30 -107 -39 -81 -135 -187 -207 -229 l-47 -27 -43 27 c-93 57 -187 171 -228 274 -11 28 -20 54 -20 58 0 4 31 6 69 4 64 -4 70 -2 81 19 12 22 13 22 27 -12 7 -18 18 -36 23 -39 5 -3 18 -44 28 -90 11 -47 22 -78 25 -70 11 33 38 182 44 244 3 36 9 66 13 66 3 0 14 -45 25 -100z" />
  </g>
</svg>

);

export default CorrGuardShield;
